import request from '@/utils/request'

export function supplierPageList(query, data) {
  return request({
    url: '/power/supplier/pageList',
    method: 'POST',
    params: query,
    data,
  })
}

// 导出
export function supplierExport() {
  return '/power/supplier/export'
}

// 转移对接采购
export function supplierEditContactUser(data) {
  return request({
    url: '/power/supplier/edit/contactUser',
    method: 'POST',
    data,
  })
}

// 详情
export function supplierDetail(query) {
  return request({
    url: '/power/supplier/detail',
    method: 'get',
    params: query,
  })
}

export function supplierChoose(query, data) {
  return request({
    url: '/power/supplier/choose/pageList',
    method: 'POST',
    params: query,
    data,
  })
}

// 供应商新增
export function supplierAdd(data) {
  return request({
    url: '/power/supplier/add',
    method: 'POST',
    data,
  })
}

// 编辑公司基本信息
export function supplierEditCompany(data) {
  return request({
    url: '/power/supplier/edit/company',
    method: 'POST',
    data,
  })
}
// 编辑一件代发
export function supplierEditPieceDelivery(data) {
  return request({
    url: '/power/supplier/edit/pieceDelivery',
    method: 'POST',
    data,
  })
}

// 编辑结算账户
export function supplierEditAccount(data) {
  return request({
    url: '/power/supplier/edit/account',
    method: 'POST',
    data,
  })
}

// 编辑附件信息
export function supplierEditAttachment(data) {
  return request({
    url: '/power/supplier/edit/attachment',
    method: 'POST',
    data,
  })
}

// 编辑收获地址
export function supplierEditAddress(data) {
  return request({
    url: '/power/supplier/edit/address',
    method: 'POST',
    data,
  })
}

// 编辑供应商关联
export function supplierEditRelation(data) {
  return request({
    url: '/power/supplier/edit/relation',
    method: 'POST',
    data,
  })
}

// 编辑拓展信息
export function supplierEditExpansion(data) {
  return request({
    url: '/power/supplier/edit/expansion',
    method: 'POST',
    data,
  })
}

// 校验供应商名称
export function supplierCheckName(query) {
  return request({
    url: '/power/supplier/checkName',
    method: 'get',
    params: query,
  })
}

export function supplierResetPassword(data) {
  return request({
    url: '/power/supplier/resetPassword',
    method: 'POST',
    data,
  })
}
